module.exports = __webpack_public_path__ + "img/47.a794652d.png";